/**
 * Canonicalize a video-model clock value before it enters Script.
 *
 * Models occasionally express the exact minute boundary as `00:60`. The value
 * is unambiguous, so carry overflow into the next minute. Values that are not a
 * clock-shaped string stay unchanged and are reported by Script validation.
 */
export function normalizeVideoTimestamp(raw: unknown): string {
  const input = typeof raw === "string" ? raw.trim().replace(/\.\d+$/, "") : "";
  const match = input.match(/^(?:(\d+):)?(\d+):(\d{2})$/);
  if (!match) return input;
  const hours = Number(match[1] ?? 0);
  const minutes = Number(match[2]);
  const seconds = Number(match[3]);
  if (![hours, minutes, seconds].every(Number.isSafeInteger)) return input;
  const totalSeconds = hours * 3600 + minutes * 60 + seconds;
  const canonicalHours = Math.floor(totalSeconds / 3600);
  const canonicalMinutes = Math.floor((totalSeconds % 3600) / 60);
  const canonicalSeconds = totalSeconds % 60;
  return canonicalHours > 0
    ? `${canonicalHours}:${String(canonicalMinutes).padStart(2, "0")}:${String(canonicalSeconds).padStart(2, "0")}`
    : `${String(canonicalMinutes).padStart(2, "0")}:${String(canonicalSeconds).padStart(2, "0")}`;
}
